import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import DisbursementChecklistSF from '../../../components/superUser/loan/DisbursementChecklistSF'

const LoanDisbursementPageUI = ({context, errorList, loan, loanBankAccount, onRefreshClick,
  }) =>
  <SuperUserLoanPageUI context={context} className='pg_su_loan_a_lst'
    backLink={`/su/loans${loan && (loan.status === 'closed' ? '/closed' : (loan.status === 'disbursed' ? '/disbursed' : ''))}`}
    headerText={loan ? (loan.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList} loan={loan} page='disbursement' dimension='w768'
  >
    {
      (!loan || !errorList) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan &&
      <div>
        <DisbursementChecklistSF context={context} loan={loan} loanBankAccount={loanBankAccount}
          onRefreshClick={onRefreshClick} />

      </div>
    }
  </SuperUserLoanPageUI>

export default LoanDisbursementPageUI
